import { ApiConstants } from '../../constants/actions';
import createReducer from '../../helpers/CreateReducer';

interface DepositState {
  isProcessing: boolean;
  noPersistance: boolean;
}

export const getInitialState = (): DepositState => ({
  isProcessing: false,
  noPersistance: true
});

export default createReducer(getInitialState, {
  [`${ApiConstants.DEPOSIT_COMPANY_ACCOUNT}_REQUEST`]:
    (): Partial<DepositState> => ({
      isProcessing: true
    }),

  [`${ApiConstants.DEPOSIT_COMPANY_ACCOUNT}_FAILURE`]:
    (): Partial<DepositState> => ({
      isProcessing: false
    }),

  [`${ApiConstants.DEPOSIT_COMPANY_ACCOUNT}_SUCCESS`]:
    (): Partial<DepositState> => ({
      isProcessing: false
    })
});
